import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

function getFormField(formId, options) {
  const url = process.env.REACT_APP_API + '/form_fields/' + formId + '?current_company=' + localStorage.current_company_id
    + ((options && options.recordDescriptor) ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');
  return axios({
    url,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }).then(response => {
    return response.data;
  }).catch(error => {
    return serviceUtil.resultForError(error);
  });
}

function updateFormField(field, completionStepId, eventMetadatum, options) {
  const url = process.env.REACT_APP_API + '/completion_criteria/' + completionStepId  +  '/form_fields/' + field.id + '?current_company=' + localStorage.current_company_id
    + ((options && options.recordDescriptor) ? ('&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor)) : '');

  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  
  return axios({
    method: 'patch',
    url,
    data: {
      event_metadatum: eventMetadatum,
      form_field: field,
    },
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }).then(response => {
    return response.data;
  }).catch(error => {
    return serviceUtil.resultForError(error);
  });
}

function submitFormFields(taskId, completionStepId, submitPairs, options) {
  let request = process.env.REACT_APP_API + '/tasks/' + taskId + '/completion_criteria/' + completionStepId + '/submit_form_fields?current_company=' + localStorage.current_company_id;

  if (options && options.recordDescriptor) {
    //added this for now so we can descriminate between old and new calls
    request += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
  }
  return axios({
    method: 'patch',
    url: request,
    data: {
      submit_list: submitPairs,
    },
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Token token=' + localStorage.token,
    },
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
}
export default {
  getFormField,
  updateFormField,
  submitFormFields,
};



// WEBPACK FOOTER //
// ./src/services/formFieldsService.js